module.exports = __webpack_public_path__ + "img/Ficha tecnica.0f0b7f9a.svg";